import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { 
    MELOGY_TRANSPARENT, 
    SECONDARY, 
    MELOGY_WHITE,
} from "../../style/colors"
import {
    BUTTON_FONT_FAMILY,
    BUTTON_FONT_WEIGHT,
    BUTTON_LETTER_SPACING,
    FONT_SIZE_S,
} from "../../style/fontSettings"
import { showToastError } from "../../style/ShowToast"

const SettingsContainer = styled.div`
    width: 100%;
    max-width: 960px;
    height: 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${MELOGY_TRANSPARENT};

    ::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none;
`

const SettingsBackGround = styled.div`
    color: ${SECONDARY};
    background-color: ${MELOGY_TRANSPARENT};
    width: 80%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
`

const SongName = styled.input`
    font-family: ${BUTTON_FONT_FAMILY};
    font-weight: ${BUTTON_FONT_WEIGHT};
    letter-spacing: ${BUTTON_LETTER_SPACING};
    font-size: ${FONT_SIZE_S};
    height: 32px;
    width: 100%;
    color: ${MELOGY_WHITE};
    background-color: ${MELOGY_TRANSPARENT};
    border: none;
    text-align: center;

    &:focus {
        outline: none;
    }
`

function Settings({
    selectedSong,
    setSongName,
    isNameUnique,
}) {
    const [tempSongName, setTempSongName] = useState(
        selectedSong ? selectedSong.name : ""
    )

    useEffect(() => {
        if (selectedSong) {
            setTempSongName(selectedSong.name)
        }
    }, [selectedSong])

    const validateAndSetSongName = () => {
        // If the song name is the same as before, no need to validate
        if (tempSongName === selectedSong.name) {
            return
        }

        // Step 1: Whitelist allowed characters (alphanumeric and some special characters)
        const regex = /^[a-zA-Z0-9.\-_, !?]+$/

        if (!regex.test(tempSongName)) {
            showToastError("Invalid characters in the song name", 5000)
            setSongName(selectedSong.name)
            return
        }

        // Step 2: Length Check
        if (tempSongName.length > 42) {
            showToastError("Song name should be at most 42 characters", 5000)
            setSongName(selectedSong.name)
            return
        }

        // Step 3: Check if the song name is unique
        if (isNameUnique(tempSongName)) {
            setSongName(tempSongName)
        } else {
            showToastError("Song name should be unique", 5000)
            setSongName(selectedSong.name)
        }
    }

    return (
        <>
            {selectedSong && (
                <SettingsContainer>
                    <SettingsBackGround>
                        <SongName
                            value={tempSongName}
                            onChange={(e) =>
                                setTempSongName(e.target.value)
                            }
                            onBlur={validateAndSetSongName}
                        />
                    </SettingsBackGround>
                </SettingsContainer>
            )}
        </>
    )
}

export default Settings
